import { Card, Flex, Row, theme, Typography } from 'antd'
import { formatter } from "../../utils/formatterUSD"
import { RightOutlined } from '@ant-design/icons'
import { CSSProperties } from "react"

type TooltipProps = {
    name: string,
    id: string,
    type: string,
    amountUSDIn: number,
    amountUSDOut: number,
    addressesCount: number
} & {isPending: boolean}

export const NodeTooltip = (tooltip: TooltipProps & {style?: CSSProperties}) => {
    const { token } = theme.useToken()
    const regularText = { fontSize: token.fontSizeSM + 'px' }
    const titleText = { fontSize: token.fontSize + 'px' }

    return (
        <Card
            style={{
                position: 'absolute',
                zIndex: 1,
                ...tooltip.style,
            }}
            bodyStyle={{ padding: token.paddingXS }}
            title={false}
        >

            <Flex gap={token.paddingXS} align="center">
                {tooltip.amountUSDIn > 0 && <>
                    <Card
                        style={{ maxWidth: '120px' }}
                        bodyStyle={{ padding: token.paddingXS }}
                    >
                        <Row justify="center">
                            <Typography.Text
                                type="success"
                                style={regularText}
                            >
                                    In
                            </Typography.Text>
                        </Row>
                        <Row justify="center">
                            <Typography.Text
                                type="secondary"
                                strong
                                style={regularText}
                            >
                                {formatter.format(tooltip.amountUSDIn)}
                            </Typography.Text>
                        </Row>
                    </Card>
                    <RightOutlined/>
                </>}
                <Flex style={{ maxWidth: '120px' }} vertical align='center'>
                    <Typography.Text
                        style={titleText}
                        strong
                        ellipsis
                    >
                        {tooltip.name}
                    </Typography.Text>
                    <Typography.Text
                        style={titleText}
                        ellipsis
                    >
                        {tooltip.addressesCount} address(-es)
                    </Typography.Text>
                </Flex>
                {tooltip.amountUSDOut > 0 && <>
                    <RightOutlined />
                    <Card
                        style={{ maxWidth: '120px' }}
                        bodyStyle={{ padding: token.paddingXS }}
                    >
                        <Row justify="center">
                            <Typography.Text
                                type='warning'
                                style={regularText}
                            >
                                    Out
                            </Typography.Text>
                        </Row>
                        <Row justify="center">
                            <Typography.Text
                                type='secondary'
                                strong
                                style={regularText}
                            >
                                {formatter.format(tooltip.amountUSDOut)}
                            </Typography.Text>
                        </Row>
                    </Card>
                </>}
            </Flex>
        </Card>
    )
}
